export const Resources = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.38281 3.92188H4.50781C4.11086 3.92188 3.78906 4.24367 3.78906 4.64062V19.0156C3.78906 19.4126 4.11086 19.7344 4.50781 19.7344H7.38281C7.77976 19.7344 8.10156 19.4126 8.10156 19.0156V4.64062C8.10156 4.24367 7.77976 3.92188 7.38281 3.92188Z"
      stroke="currentColor"
      strokeWidth="1.4375"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.78906 7.51562H8.10156"
      stroke="currentColor"
      strokeWidth="1.4375"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.6953 3.92188H8.82031C8.42336 3.92188 8.10156 4.24367 8.10156 4.64062V19.0156C8.10156 19.4126 8.42336 19.7344 8.82031 19.7344H11.6953C12.0923 19.7344 12.4141 19.4126 12.4141 19.0156V4.64062C12.4141 4.24367 12.0923 3.92188 11.6953 3.92188Z"
      stroke="currentColor"
      strokeWidth="1.4375"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.10156 16.1406H12.4141"
      stroke="currentColor"
      strokeWidth="1.4375"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.9659 3.6869L13.1772 4.4344C12.7922 4.53761 12.5637 4.93341 12.6668 5.31846L16.4043 19.2622C16.5076 19.6472 16.9034 19.8758 17.2884 19.7726L20.0772 19.0251C20.4622 18.9218 20.6907 18.526 20.5875 18.141L16.85 4.19721C16.7469 3.81216 16.351 3.58369 15.9659 3.6869Z"
      stroke="currentColor"
      strokeWidth="1.4375"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.5764 16.4282L19.7452 15.3052"
      stroke="currentColor"
      strokeWidth="1.4375"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.3484 8.09063L17.5171 6.97656"
      stroke="currentColor"
      strokeWidth="1.4375"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
